import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { __rest } from "tslib";
import React, { useState, useRef, useCallback } from 'react';
import { VideoPlayer } from 'panamera-react-ui';
var css = {
  "playerWrapper": "oalp-3HJZ9",
  "videoOverlay": "oalp-mtYU7",
  "titleSection": "oalp-VsWf_",
  "portrait": "oalp-Wgp-a",
  "cta": "oalp-2O6F8",
  "ctaWithText": "oalp-u0zSO",
  "landscape": "oalp-2gxYP",
  "ctaText": "oalp-3xvza",
  "benefits": "oalp-yfvGN"
};
import VideoOverlay from "./VideoOverlay";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import { FLOW_TYPES, CHOOSEN_OPTIONS } from "../../Constants/video";
export var BuyVideoWidget = function BuyVideoWidget(_ref) {
  var data = _ref.data,
    name = _ref.name,
    track = _ref.track,
    ReactObserver = _ref.ReactObserver;
  var video = data.video,
    thumbnail = data.thumbnail,
    _data$controls = data.controls,
    controls = _data$controls === void 0 ? true : _data$controls,
    _data$controlsList = data.controlsList,
    controlsList = _data$controlsList === void 0 ? '' : _data$controlsList,
    _data$disablePictureI = data.disablePictureInPicture,
    disablePictureInPicture = _data$disablePictureI === void 0 ? true : _data$disablePictureI,
    title = data.title,
    crossIcon = data.crossIcon,
    ctaWithText = data.ctaWithText,
    cta = data.cta,
    benefits = data.benefits,
    widgetTitleTop = data.widgetTitleTop,
    widgetTitleBottom = data.widgetTitleBottom,
    widgetSubtitleTop = data.widgetSubtitleTop,
    widgetSubtitleBottom = data.widgetSubtitleBottom,
    _data$isLazyLoaded = data.isLazyLoaded,
    isLazyLoaded = _data$isLazyLoaded === void 0 ? false : _data$isLazyLoaded;
  var player = useRef(null);
  var bufferTime = useRef(0);
  var thumbnailSrc = thumbnail.src;
  var videoSrc = video.src;
  var _a = thumbnail && thumbnail.style || {},
    thumbnailWidth = _a.width,
    thumbnailHeight = _a.height,
    thumbnailStyle = __rest(_a, ["width", "height"]);
  var _useState = useState({
      width: thumbnailWidth,
      height: thumbnailHeight,
      style: thumbnailStyle,
      isFullscreen: false,
      playing: false,
      paused: false,
      ended: false,
      landscape: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    playerState = _useState2[0],
    setPlayerState = _useState2[1];
  var bufferStartTime = 0;
  var _useState3 = useState(isLazyLoaded),
    _useState4 = _slicedToArray(_useState3, 2),
    isInViewPort = _useState4[0],
    setIsInViewPort = _useState4[1];
  function onClickPreview() {
    var _a = video && video.style || {},
      videoWidth = _a.width,
      videoHeight = _a.height,
      videoStyle = __rest(_a, ["width", "height"]);
    setPlayerState(Object.assign(Object.assign({}, playerState), {
      width: videoWidth,
      height: videoHeight,
      style: videoStyle,
      isFullscreen: true,
      playing: true,
      paused: false,
      ended: false
    }));
    bufferStartTime = Date.now();
    if (track) {
      var trackingInfo = {
        chosen_option: CHOOSEN_OPTIONS.VIDEO_START,
        select_from: name
      };
      track(TRACKING_EVENTS.AUTOS_LP_BUTTON_TAPPED, trackingInfo);
    }
  }
  var getVideoInfo = function getVideoInfo() {
    var totalDuration = player.current && player.current.getDuration() || 0;
    var currentTime = player.current && player.current.getCurrentTime() || 0;
    return {
      result_count: totalDuration,
      time_spent: currentTime,
      flow_type: totalDuration === currentTime ? FLOW_TYPES.END_REACHED : FLOW_TYPES.END_NOT_REACHED,
      extended_distance: bufferTime.current
    };
  };
  var onTrack = function onTrack(event, additionalInfo) {
    if (track) {
      var trackingInfo = {};
      track(event, Object.assign(Object.assign({}, trackingInfo), additionalInfo));
    }
  };
  var fireStartPlayingEvent = function fireStartPlayingEvent() {
    var videoCurrenTime = player.current && player.current.getCurrentTime() || 0;
    var trackProps = {
      result_count: Math.floor(videoCurrenTime),
      time_spent: bufferTime.current
    };
    onTrack(TRACKING_EVENTS.LP_VIDEO_START_PLAYING, trackProps);
  };
  function handleCtaClick() {
    onTrack(TRACKING_EVENTS.LP_VIDEO_FINISHES, Object.assign(Object.assign({}, getVideoInfo()), {
      chosen_option: CHOOSEN_OPTIONS.CTA_CLICK
    }));
  }
  function handleCrossButton() {
    setPlayerState(Object.assign(Object.assign({}, playerState), {
      width: thumbnailWidth,
      height: thumbnailHeight,
      style: thumbnailStyle,
      isFullscreen: false
    }));
    onTrack(TRACKING_EVENTS.LP_VIDEO_FINISHES, Object.assign(Object.assign({}, getVideoInfo()), {
      chosen_option: CHOOSEN_OPTIONS.CROSS
    }));
  }
  function handleVideoPlay() {
    setPlayerState(Object.assign(Object.assign({}, playerState), {
      playing: true,
      paused: false,
      ended: false
    }));
    onTrack(TRACKING_EVENTS.LP_VIDEO_INTERACTION, {
      chosen_option: CHOOSEN_OPTIONS.VIDEO_PLAY
    });
  }
  function handleVideoPause() {
    setPlayerState(Object.assign(Object.assign({}, playerState), {
      playing: false,
      paused: true,
      ended: false
    }));
    onTrack(TRACKING_EVENTS.LP_VIDEO_INTERACTION, {
      chosen_option: CHOOSEN_OPTIONS.VIDEO_PAUSE
    });
  }
  function handleVideoEnd() {
    setPlayerState(Object.assign(Object.assign({}, playerState), {
      playing: false,
      paused: false,
      ended: true
    }));
  }
  function handleVideoError(error) {
    onTrack(TRACKING_EVENTS.LP_VIDEO_ERROR, {
      error_type: error
    });
  }
  function handleBufferStart() {
    bufferStartTime = Date.now();
  }
  function handleBufferEnd() {
    if (bufferStartTime) {
      var totalBufferTime = Date.now() - bufferStartTime;
      bufferTime.current += Math.floor(totalBufferTime / 1000);
      bufferStartTime = 0;
    }
    fireStartPlayingEvent();
  }
  function handleVideoStart() {
    fireStartPlayingEvent();
  }
  var handleInViewEvent = useCallback(function (inView) {
    if (inView) {
      setIsInViewPort(true);
      if (track) {
        track(TRACKING_EVENTS.LP_VIDEO_SHOWN, {
          select_from: name
        });
      }
    }
  }, [track, name]);
  var getListOfBenefits = function getListOfBenefits() {
    return benefits && /*#__PURE__*/React.createElement("ul", {
      className: css.benefits
    }, benefits.map(function (item) {
      return /*#__PURE__*/React.createElement("li", null, item);
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !playerState.isFullscreen && /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleInViewEvent,
    "data-aut-id": "observer"
  }, widgetTitleTop && widgetTitleTop.text && /*#__PURE__*/React.createElement("div", {
    style: widgetTitleTop.style
  }, widgetTitleTop.text), widgetSubtitleTop && widgetSubtitleTop.text && /*#__PURE__*/React.createElement("div", {
    style: widgetSubtitleTop.style
  }, widgetSubtitleTop.text), getListOfBenefits(), isInViewPort ? /*#__PURE__*/React.createElement(VideoPlayer, {
    url: videoSrc,
    light: thumbnailSrc,
    controls: false,
    controlsList: controlsList,
    disablePictureInPicture: disablePictureInPicture,
    handleClickPreview: onClickPreview,
    playing: false,
    width: playerState.width,
    height: playerState.height,
    style: playerState.style,
    onError: handleVideoError
  }) : null, widgetTitleBottom && widgetTitleBottom.text && /*#__PURE__*/React.createElement("div", {
    style: widgetTitleBottom.style
  }, widgetTitleBottom.text), widgetSubtitleBottom && widgetSubtitleBottom.text && /*#__PURE__*/React.createElement("div", {
    style: widgetSubtitleBottom.style
  }, widgetSubtitleBottom.text))), playerState.isFullscreen && /*#__PURE__*/React.createElement("div", {
    className: css.playerWrapper
  }, /*#__PURE__*/React.createElement(VideoOverlay, {
    handleCrossButton: handleCrossButton,
    title: title,
    crossIcon: crossIcon,
    name: name,
    ctaWithText: ctaWithText,
    isPlaying: playerState.playing,
    cta: cta,
    track: track,
    handleCtaClick: handleCtaClick
  }), /*#__PURE__*/React.createElement(VideoPlayer, {
    url: videoSrc,
    controls: controls,
    controlsList: controlsList,
    disablePictureInPicture: disablePictureInPicture,
    handleClickPreview: onClickPreview,
    playing: true,
    width: playerState.width,
    height: playerState.height,
    style: playerState.style,
    onEnded: handleVideoEnd,
    onPlay: handleVideoPlay,
    onPause: handleVideoPause,
    onError: handleVideoError,
    player: player,
    onBuffer: handleBufferStart,
    onBufferEnd: handleBufferEnd,
    onStart: handleVideoStart
  })));
};
export default withComponentDependency(BuyVideoWidget);